module.exports = __webpack_public_path__ + "img/ins_nor.df8dee6f.svg";